import React, {useState, useRef, useEffect} from "react";
import {
    Typography,
    Grid,
    TextField as RTextField,
    Button,
    Select,
    MenuItem,
    makeStyles,
    Container, CircularProgress, Box,
} from "@material-ui/core";
import {Formik, Form, Field, ErrorMessage} from "formik";
import {TextField} from "formik-material-ui";
import { colorError,} from "../../../Constants/theme";
import {generalColors, dogsAndCatsColors} from "../../../Constants/colors";
import {petTypes as hrPetTypes, rhapsodyPetTypes} from "../../../Constants/specialities";
import { dogs } from "../../../Constants/dogs";
import { cats } from "../../../Constants/cats";
import { amphibians } from "../../../Constants/amphibians";
import { aquatic } from "../../../Constants/aquatic";
import { rodent } from "../../../Constants/rodent";
import { mustelidae } from "../../../Constants/mustelodae";
import { birds } from "../../../Constants/birds";
import * as Yup from "yup";
import { Autocomplete } from "@material-ui/lab";
import {useSelector} from "react-redux";
import {RootState, useAppDispatch} from "../../../redux/store";
import {setPetType} from "../../../utils/petInfo";
import {
    BASIC_PET_TYPE_OPTIONS,
    getBasicTypeSelection,
    getOtherPetTypes,
    isBasicPetType,
    PetTypeOption,
} from "../../../utils/petTypeOptions";
import {editAnimal} from "../../../redux/pets/pets.actions";
import { useSnackbar } from "notistack";
import {api_setAnimal} from "../../../redux/pets/pets.api";
import {DatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import moment from "moment";

interface Props {
	  changeCount: (number: number) => void;
    isWhiteLabel: boolean;
    pet: any;
    setPet: React.Dispatch<React.SetStateAction<{
        id: number;
        ownerId: number;
        type: string;
        name: string;
        breed: string;
        weight: number;
        sex: string;
        neuteredSpayed: boolean;
        vaccines: any[];
        medications: any[];
        allergies: any[];
        chronicConditions: any[];
        dateOfBirth: string;
        imageUrl: string;
    }>>;
    petId: number;
    setPetId: React.Dispatch<React.SetStateAction<number>>;
    animalType: string;
    setAnimalType: React.Dispatch<React.SetStateAction<string>>;
    initialPetType?: string;
}

const useStyle = makeStyles(() => ({
    body: {
        paddingTop: 20,
    },
    spacing: {
        paddingTop: 20,
    },
    cancelButton: {
        border: `1.5px solid ${colorError}`,
        color: colorError
    },
    formError: {
        color: colorError,
        fontSize: "12px",
        marginLeft: "14px",
        marginTop: "4px"
    }
}));

const Pet = ({changeCount, isWhiteLabel, pet, setPet, petId, setPetId, animalType, setAnimalType, initialPetType = ""}: Props) => {
    const classes = useStyle();
    const dispatch = useAppDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const clinicId = useSelector((state: RootState) => state?.branding.clinicId);
    const pets = useSelector((state: RootState) => state?.pets.petsList);
    const validationSchema = Yup.object().shape({
        name: Yup.string().required("Required"),
        type: Yup.string().required("Required"),
        dateOfBirth: Yup.string().required("Required"),
        weight: Yup.number().typeError("Required").required("Required"),
        breed: Yup.string().nullable().required("Required"),
        primaryColor: Yup.string().required("Required"),
    });
    const user = useSelector((state: RootState) => state?.user);
    const setType = (type: PetTypeOption) => {
        const petType = setPetType(type.value);
        setAnimalType(petType);
    };
    const [formikValues, setFormikValues] = useState({
        name: "",
        type: initialPetType,
        breed: "",
        dateOfBirth: "",
        weight: null,
        primaryColor: "",
        secondaryColor: ""
    });
    const [linkToImage, setLinkToImage] = useState("");
    const petTypes: PetTypeOption[] = clinicId ? rhapsodyPetTypes : hrPetTypes;
    const otherPetTypes = getOtherPetTypes(petTypes);
    const [isOtherTypeSelected, setIsOtherTypeSelected] = useState(
        () => !!initialPetType && !isBasicPetType(initialPetType)
    );
    const [isLoading, setIsLoading] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);
    const [isType, setIsType] = useState(false);
    const [isBirthday, setIsBirthday] = useState(false);
    const [isBreed, setIsBreed] = useState(false);
    const [isPrimaryColor, setIsPrimaryColor] = useState(false);
    useEffect(() => {
        window.scrollTo(0,0);
        if (petId) {
            if (petId === 0) {
                return;
            }
            // setPet(findPet)
            setLinkToImage(pet?.imageUrl);
            const resolvedType = (() => {
                    const petType = pet?.type === "Other"? pet?.breed : pet?.type;
                    const reg = new RegExp(petType, "i");
                    let type = "Other";
                    petTypes.forEach(item => {
                        if(reg.test(item.value)) {
                            type = item.value;
                        }
                    });
                    return type;
                })();
            setIsOtherTypeSelected(!isBasicPetType(resolvedType));
            setFormikValues({
                name: pet?.name,
                type: resolvedType,
                breed: pet?.breed || "",
                weight: pet?.weight || null,
                dateOfBirth: pet?.dateOfBirth || null,
                primaryColor: Object.prototype.hasOwnProperty.call(pet,"primaryColor") ? pet["primaryColor"] : "",
                secondaryColor: Object.prototype.hasOwnProperty.call(pet,"secondaryColor") ? pet["secondaryColor"] : "",
            });

            setAnimalType(setPetType(resolvedType));
            // dispatch(getPetURLUploadImage(pet.id))
            //     .then((res) => {
            //         setUploadPhotoUrl(res.uploadUrl);
            //     });
        }
    }, [pet, petId]);

    useEffect(() => {
        if  (!initialPetType) {
            return;
        }

        const matchedType = petTypes.find(type => type.value === initialPetType);
        if (!matchedType) {
            return;
        }

        if (!isBasicPetType(matchedType.value)) {
            setIsOtherTypeSelected(true);
        }
        setFormikValues(prev => ({
            ...prev,
            type: matchedType.value,
        }));
        setType(matchedType);
    }, [initialPetType, petId, petTypes, setAnimalType]);

    useEffect(() => {
        if (petId !== 0) {
            let newPet = pets.filter(item => item.id === petId)[0];
            setPet(newPet);
            // if (Object.prototype.hasOwnProperty.call(newPet,"primaryVetName")){setClinic(newPet["primaryVetName"]); setPCV("yes")}
            // if (Object.prototype.hasOwnProperty.call(newPet,"primaryVetPhoneNumber")){setPCVPhone(newPet["primaryVetPhoneNumber"])}
        }
    }, [petId]);

    return (
        <Container className={classes.body} disableGutters={true}>
            <Typography variant="h2" gutterBottom>
                Your Pet - The Look
            </Typography>
            { isLoading ?
                <Box width="100%" height="300px" display="flex" justifyContent="center" alignItems="center">
                    <CircularProgress/>
                </Box>
                :
                <Formik
                    initialValues={formikValues}
                    enableReinitialize
                    onSubmit={async (values) => {
                        try {
                            setIsLoading(true);
                            const petName = values.name.charAt(0).toUpperCase() + values.name.slice(1).toLowerCase();
                            const primary = values.primaryColor ? values.primaryColor.toUpperCase() : "";
                            const secondary = values.secondaryColor ? values.secondaryColor.toUpperCase() : "";
                            const body = {
                                ownerId: user.userId,
                                type: values.type,
                                name: petName,
                                breed: values.breed,
                                dateOfBirth: values.dateOfBirth,
                                weight: values.weight,
                                primaryColor: primary,
                                secondaryColor: secondary
                            };

                            if (petId > 0) {
                                await dispatch(editAnimal(petId, body));
                            } else {
                                api_setAnimal(body).then((res) => {
                                    setPet(res);
                                    setPetId(res.id);
                                }).finally(() => {
                                    changeCount(1);
                                });
                            }
                        } catch (error) {
                            setIsLoading(false);
                            enqueueSnackbar(error.message || error.errorMessage, {
                                variant: "error",
                                autoHideDuration: 3000,
                            });
                        }
                    }}
                    validationSchema={validationSchema}
                >
                    {({isSubmitting, errors, values, handleChange, setFieldValue}) => (
                        <Form>
                            <Grid container spacing={2}>
                                <Grid item container alignItems="flex-start" xs={12} spacing={2}>
                                    <Grid item xs={12} container justify="space-between" alignItems="center">
                                        <Grid item xs={12} sm={3}>
                                            <Typography variant="body2" style={{marginRight: "50px"}}>
                                                Name
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={9}>
                                            <Field
                                                component={TextField}
                                                id="name"
                                                name="name"
                                                label="Name"
                                                variant="outlined"
                                                color="secondary"
                                                type="text"
                                                margin="dense"
                                                size="small"
                                                fullWidth
                                                onChange={handleChange}
                                                placeholder=""

                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} container alignItems="center">
                                        <Grid item xs={12} sm={3}>
                                            <Typography variant="body2" gutterBottom>
                                                Type
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={9}>
                                            <Autocomplete<PetTypeOption, false, true, false>
                                                fullWidth
                                                options={BASIC_PET_TYPE_OPTIONS}
                                                disableClearable
                                                getOptionLabel={(option) => option.label}
                                                value={getBasicTypeSelection(values.type, isOtherTypeSelected)}
                                                onChange={(event, value: PetTypeOption) => {
                                                    if (value.value === "OTHER") {
                                                        setIsOtherTypeSelected(true);
                                                        setFieldValue("type", "");
                                                        setFieldValue("breed", "");
                                                        setAnimalType("Other");
                                                        setIsType(false);
                                                        return;
                                                    }
                                                    setIsOtherTypeSelected(false);
                                                    setFieldValue("type", value.value);
                                                    setType(value);
                                                    setFieldValue("breed", "");
                                                    setIsType(false);
                                                }}
                                                onBlur={() => {
                                                    if (!getBasicTypeSelection(values.type, isOtherTypeSelected)) {
                                                        setIsType(true);
                                                    }
                                                }}
                                                renderInput={(params) =>
                                                    <>
                                                        <RTextField {...params}
                                                            error={!getBasicTypeSelection(values.type, isOtherTypeSelected) && (isType || isSubmit)}
                                                            margin="dense"
                                                            variant="outlined"
                                                            label="Type"
                                                        />
                                                        {!getBasicTypeSelection(values.type, isOtherTypeSelected) && (isType || isSubmit) && <Typography
                                                            className={classes.formError}>Required</Typography>}
                                                    </>}
                                            />
                                            {isOtherTypeSelected &&
                                                <Box marginTop={1}>
                                                    <Autocomplete<PetTypeOption, false, true, false>
                                                        fullWidth
                                                        options={otherPetTypes}
                                                        disableClearable
                                                        getOptionLabel={(option) => option.label}
                                                        value={otherPetTypes.find(type => type.value === values.type) || null}
                                                        onChange={(event, value: PetTypeOption) => {
                                                            setFieldValue("type", value.value);
                                                            setType(value);
                                                            setFieldValue("breed", "");
                                                            setIsType(false);
                                                        }}
                                                        onBlur={() => {
                                                            if (!values.type.length) {
                                                                setIsType(true);
                                                            }
                                                        }}
                                                        renderInput={(params) =>
                                                            <>
                                                                <RTextField {...params}
                                                                    error={!values.type && (isType || isSubmit)}
                                                                    margin="dense"
                                                                    variant="outlined"
                                                                    label="Other type"
                                                                />
                                                                {!values.type && (isType || isSubmit) && <Typography
                                                                    className={classes.formError}>Required</Typography>}
                                                            </>}
                                                    />
                                                </Box>
                                            }
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} container alignItems="center">
                                        <Grid item xs={12} sm={3}>
                                            <Typography variant="body2">
                                                Breed
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={9}>
                                            {animalType === "CANINE" &&
                                        <Autocomplete
                                        	fullWidth
                                        	options={dogs}
                                            disableClearable
                                        	getOptionLabel={(option) => option}
                                        	value={values.breed}
                                        	onChange={(event, value) => {
                                        		setFieldValue("breed", value);
                                                setIsBreed(false);
                                        	}}
                                            onBlur={()=>{
                                                if (!values.breed.length) {
                                                    setFieldValue("breed", "");
                                                    setIsBreed(true);
                                                }
                                            }}
                                        	renderInput={(params) =>
                                                <>
                                                    <RTextField {...params} error={(isSubmit || isBreed) && !values.breed} margin="dense" variant="outlined" label="Breed"/>
                                                    {(!values.breed && (isBreed || isSubmit)) && <Typography
                                                        className={classes.formError}>Required</Typography>}
                                                </>
                                            }
                                        />
                                            }
                                            {animalType === "FELINE" &&
                                        <Autocomplete
                                        	fullWidth
                                        	options={cats}
                                            disableClearable
                                        	getOptionLabel={(option) => option}
                                        	value={values.breed}
                                        	onChange={(event, value) => {
                                        		setFieldValue("breed", value);
                                                setIsBreed(false);
                                        	}}
                                            onBlur={()=>{
                                                if (!values.breed.length) {
                                                    setFieldValue("breed", "");
                                                    setIsBreed(true);
                                                }
                                            }}
                                        	renderInput={(params) =>
                                                <>
                                                    <RTextField {...params} error={(isSubmit || isBreed) && !values.breed} margin="dense" variant="outlined" label="Breed"/>
                                                    {(!values.breed && (isBreed || isSubmit)) && <Typography
                                                        className={classes.formError}>Required</Typography>}
                                                </>
                                        	}
                                        />
                                            }
                                            {animalType === "AVIAN" &&
                                        <Autocomplete
                                            fullWidth
                                            options={birds}
                                            disableClearable
                                            getOptionLabel={(option) => option}
                                            value={values.breed}
                                            onChange={(event, value) => {
                                                setFieldValue("breed", value);
                                                setIsBreed(false);
                                            }}
                                            onBlur={()=>{
                                                if (!values.breed.length) {
                                                    setFieldValue("breed", "");
                                                    setIsBreed(true);
                                                }
                                            }}
                                            renderInput={(params) =>
                                                <>
                                                    <RTextField {...params} error={(isSubmit || isBreed) && !values.breed} margin="dense" variant="outlined" label="Breed"/>
                                                    {(!values.breed && (isBreed || isSubmit)) && <Typography
                                                        className={classes.formError}>Required</Typography>}
                                                </>
                                            }
                                        />
                                            }
                                            {animalType === "AMPHIBIAN" &&
                                        <Autocomplete
                                            fullWidth
                                            options={amphibians}
                                            disableClearable
                                            getOptionLabel={(option) => option}
                                            value={values.breed}
                                            onChange={(event, value) => {
                                                setFieldValue("breed", value);
                                                setIsBreed(false);
                                            }}
                                            onBlur={()=>{
                                                if (!values.breed.length) {
                                                    setFieldValue("breed", "");
                                                    setIsBreed(true);
                                                }
                                            }}
                                            renderInput={(params) =>
                                                <>
                                                    <RTextField {...params} error={(isSubmit || isBreed) && !values.breed} margin="dense" variant="outlined" label="Breed"/>
                                                    {(!values.breed && (isBreed || isSubmit)) && <Typography
                                                        className={classes.formError}>Required</Typography>}
                                                </>
                                            }
                                        />
                                            }
                                            {animalType === "AQUATIC" &&
                                        <Autocomplete
                                            fullWidth
                                            options={aquatic}
                                            disableClearable
                                            getOptionLabel={(option) => option}
                                            value={values.breed}
                                            onChange={(event, value) => {
                                                setFieldValue("breed", value);
                                                setIsBreed(false);
                                            }}
                                            onBlur={()=>{
                                                if (!values.breed.length) {
                                                    setFieldValue("breed", "");
                                                    setIsBreed(true);
                                                }
                                            }}
                                            renderInput={(params) =>
                                                <>
                                                    <RTextField {...params} error={(isSubmit || isBreed) && !values.breed} margin="dense" variant="outlined" label="Breed"/>
                                                    {(!values.breed && (isBreed || isSubmit)) && <Typography
                                                        className={classes.formError}>Required</Typography>}
                                                </>
                                            }
                                        />
                                            }
                                            {animalType === "MUSTELIDAE" &&
                                        <Autocomplete
                                            fullWidth
                                            options={mustelidae}
                                            disableClearable
                                            getOptionLabel={(option) => option}
                                            value={values.breed}
                                            onChange={(event, value) => {
                                                setFieldValue("breed", value);
                                                setIsBreed(false);
                                            }}
                                            onBlur={()=>{
                                                if (!values.breed.length) {
                                                    setFieldValue("breed", "");
                                                    setIsBreed(true);
                                                }
                                            }}
                                            renderInput={(params) =>
                                                <>
                                                    <RTextField {...params} error={(isSubmit || isBreed) && !values.breed} margin="dense" variant="outlined" label="Breed"/>
                                                    {(!values.breed && (isBreed || isSubmit)) && <Typography
                                                        className={classes.formError}>Required</Typography>}
                                                </>
                                            }
                                        />
                                            }
                                            {animalType === "Other" && <Field
                                                component={TextField}
                                                id="breed"
                                                name="breed"
                                                label="Breed"
                                                variant="outlined"
                                                color="secondary"
                                                type="text"
                                                margin="dense"
                                                size="small"
                                                fullWidth
                                                onChange={handleChange}
                                                placeholder=""
                                            />}
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} container alignItems="center">
                                        <Grid item xs={12} sm={3}>
                                            <Typography variant="body2">
                                                Birthdate
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={9}>
                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <DatePicker
                                                    defaultValue={moment().format("YYYY-MM-DD")}
                                                    name="dateOfBirth"
                                                    inputVariant="outlined"
                                                    openTo="year"
                                                    label="Birthdate"
                                                    error={(isSubmit || isBirthday) && !values.dateOfBirth}
                                                    views={["year", "month", "date"]}
                                                    value={values.dateOfBirth || null}
                                                    fullWidth={true}
                                                    size="small"
                                                    format="MM/dd/yyyy"
                                                    disableFuture={true}
                                                    maxDate={new Date()}
                                                    minDate={new Date("1990-01-01")}
                                                    onChange={(val) => {
                                                        setFieldValue("dateOfBirth", moment(val).format("YYYY-MM-DD"));
                                                        setIsBirthday(false);
                                                    }}
                                                    onBlur={() => {
                                                        if (!values.dateOfBirth?.length) {
                                                            setFieldValue("dateOfBirth", "");
                                                            setIsBirthday(true);
                                                        }
                                                    }}
                                                />
                                            </MuiPickersUtilsProvider>
                                            {(!values.dateOfBirth && (isBirthday || isSubmit)) && <Typography
                                                className={classes.formError}>Required</Typography>}
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} container alignItems="center">
                                        <Grid item xs={12} sm={3}>
                                            <Typography variant="body2">
                                                Weight
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={9} container direction="row" alignItems="center">
                                            <Grid item xs={10}>
                                                <Field
                                                    component={TextField}
                                                    fullWidth
                                                    label="Weight (your best guess)"
                                                    onChange={handleChange}
                                                    value={values.weight}
                                                    name="weight"
                                                    id="weight"
                                                    inputProps={{min: 0, step: 0.1}}
                                                    type="number"
                                                    variant="outlined"
                                                    color="secondary"
                                                    margin="dense"
                                                />
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Typography variant="body2" align="center">
                                                    lbs
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} container alignItems="center">
                                        <Grid item xs={12} sm={3}>
                                            <Typography variant="body2">
                                                Primary Color
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={9}>
                                            {(animalType === "Dog" || animalType === "Cat") &&
                                            <Autocomplete
                                            	fullWidth
                                            	options={dogsAndCatsColors}
                                                disableClearable
                                            	getOptionLabel={(option) => option}
                                            	value={values.primaryColor}
                                            	onChange={(event, value) => {
                                            		setFieldValue("primaryColor", value);
                                            	}}
                                                onBlur={()=>{
                                                    if (!values.primaryColor.length) {
                                                        setFieldValue("primaryColor", "");
                                                        setIsPrimaryColor(true);
                                                    }
                                                }}
                                            	renderInput={(params) => <>
                                                    <RTextField {...params}
                                                        error={(isSubmit || isPrimaryColor) && !values.primaryColor}
                                                        margin="dense"
                                                        variant="outlined"
                                                        label="Primary Color"
                                                    />
                                                    {(!values.primaryColor && (isPrimaryColor || isSubmit)) && <Typography
                                                        className={classes.formError}>Required</Typography>}
                                                </>}
                                            />
                                            }
                                            {(animalType !== "Cat" && animalType !== "Dog") &&
                                            <Autocomplete
                                            	fullWidth
                                            	options={generalColors}
                                                disableClearable
                                            	getOptionLabel={(option) => option}
                                            	value={values.primaryColor}
                                            	onChange={(event, value) => {
                                            		setFieldValue("primaryColor", value);
                                                    setIsPrimaryColor(false);
                                            	}}
                                                onBlur={()=>{
                                                    if (!values.primaryColor.length) {
                                                        setFieldValue("primaryColor", "");
                                                        setIsPrimaryColor(true);
                                                    }
                                                }}
                                            	renderInput={(params) => <>
                                                    <RTextField {...params}
                                                        error={(isSubmit || isPrimaryColor) && !values.primaryColor}
                                                        margin="dense"
                                                        variant="outlined"
                                                        label="Primary Color"
                                                    />
                                                    {(!values.primaryColor && (isPrimaryColor || isSubmit)) && <Typography
                                                        className={classes.formError}>Required</Typography>}
                                                </>}
                                            />
                                            }
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} container alignItems="center">
                                        <Grid item xs={12} sm={3}>
                                            <Typography variant="body2">
                                                Secondary Color <span style={{fontWeight: 400, fontSize: "12px"}}>(Optional)</span>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={9}>
                                            {(animalType === "Dog" || animalType === "Cat") &&
                                            <Autocomplete
                                            	fullWidth
                                            	options={dogsAndCatsColors}
                                            	getOptionLabel={(option) => option}
                                            	value={values.secondaryColor}
                                            	onChange={(event, value) => {
                                            		setFieldValue("secondaryColor", value);
                                                    setIsPrimaryColor(false);
                                            	}}

                                            	renderInput={(params) => <RTextField {...params} margin="dense" variant="outlined" label="Secondary Color"/>}
                                            />
                                            }
                                            {(animalType !== "Cat" && animalType !== "Dog") &&
                                            <Autocomplete
                                            	fullWidth
                                            	options={generalColors}
                                            	getOptionLabel={(option) => option}
                                            	value={values.secondaryColor}
                                            	onChange={(event, value) => {
                                            		setFieldValue("secondaryColor", value);
                                                    setIsPrimaryColor(false);
                                            	}}

                                            	renderInput={(params) => <RTextField {...params} margin="dense" variant="outlined" label="Secondary Color"/>}
                                            />
                                            }
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container justify="flex-start" spacing={2} className={classes.spacing}>
                                <Grid item xs={12} sm={3}>
                                    <Button
                                        fullWidth
                                        color="secondary"
                                        variant="outlined"
                                        type="submit"
                                        disabled={isSubmitting}
                                        data-testid="submitButton"
                                        onClick={()=> setIsSubmit(true)}
                                    >
                                        Save
                                    </Button>
                                </Grid>
                            </Grid>
                        </Form>
                    )}
                </Formik>}
        </Container>
    );
};

export default Pet;
